import * as actionTypes from '../actionTypes';
import { loadState, saveState } from './rh';

let initialState = loadState();
// let initialState;

if (initialState === undefined) {
  initialState = {
    IsAuthorized: false,
    Token: null,
    RefreshToken: null,
    Username: '',
    type: '',
  };
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTHORIZE_USER:
      const newAuth = {
        IsAuthorized: true,
        Token: action.values.accessToken,
        RefreshToken: action.values.refreshToken,
        Username: action.values.username,
        type: action.values.type,
      };
      saveState(newAuth);
      return newAuth;

    case actionTypes.LOGOUT:
      const newAuthLogout = {
        IsAuthorized: false,
        Token: null,
        RefreshToken: null,
        Username: '',
        type: '',
      };
      saveState(newAuthLogout);
      return newAuthLogout;

    default:
      return state;
  }
};

export default reducer;
